import { render, staticRenderFns } from "./DashboardLoader.vue?vue&type=template&id=6c754026&scoped=true&lang=html"
import script from "./DashboardLoader.vue?vue&type=script&lang=js"
export * from "./DashboardLoader.vue?vue&type=script&lang=js"
import style0 from "./DashboardLoader.vue?vue&type=style&index=0&id=6c754026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c754026",
  null
  
)

export default component.exports